import { apiSlice } from '../api/apiSlice'
import { ENDPOINTS } from '../../lib/endpoints'

export interface LeaderboardEntry {
  rank:        number
  userId:      string
  displayName: string
  avatarUrl:   string | null
  score:       number
  discussions: number
  comments:    number
  votes:       number
}

export interface MyRankResult {
  rank:        number | null
  score:       number
  discussions: number
  comments:    number
  votes:       number
  period:      LeaderboardPeriod
  hasActivity: boolean
}

export type LeaderboardPeriod = 'week' | 'month' | 'all'

export const leaderboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getLeaderboard: builder.query<
      { leaderboard: LeaderboardEntry[]; period: LeaderboardPeriod; total: number; page: number; limit: number; hasMore: boolean },
      { period: LeaderboardPeriod; page?: number }
    >({
      query: ({ period, page = 1 }) => ({
        url:    ENDPOINTS.leaderboard.list,
        params: { period, page, limit: 10 },
      }),
      keepUnusedDataFor: 5 * 60,
    }),

    getMyRank: builder.query<MyRankResult, LeaderboardPeriod>({
      query: (period) => ({
        url:    ENDPOINTS.leaderboard.myRank,
        params: { period },
      }),
      keepUnusedDataFor: 60, // 1 min — personal data, refresh frequently
    }),

  }),
})

export const { useGetLeaderboardQuery, useGetMyRankQuery } = leaderboardApi
